import { reduxForm, change } from 'redux-form';
import config from 'config';
import {validateRedux} from '../../../utilites/validate';
import Player from '../../../api/player';
import { push } from 'react-router-redux/lib/actions';
import PlayersEditForm from './PlayersEditForm';
import CRUDAction from '../../../actions/player';
import { PLAYERS_ROUTER_ROOT } from '../constants';
import {validateAsyncRedux} from '../../../utilites/validate';

const asyncValidate = (data) => validateAsyncRedux(data,
  {
    file: {
      presence: {message: '^Please upload an image'},
      minImageSizeAsync: config.player.imageCrop
    }
  });


const validate = (data) => {
  let {name, number, file} = Player.validateConstraints;

  return validateRedux(data, {
    number, name, file
  });
};

export default reduxForm(
  {
    form: 'player_edit_form',
    fields: [
      'name',
      'file',
      'number',
      'position',
      'age',
      'nationality',
      'foot',
      'birthday',
      'placeOfBirth'
    ],
    returnRejectedSubmitPromise: true,
    asyncBlurFields: ['file'],
    asyncValidate,
    validate
  },
  ( { player : { model, loadingItem}} ) => ({
    model,
    loading: loadingItem,
    isAbleToDelete: model && !model.isNew(),
    initialValues: Object.assign({file: (model || {}).photo }, model)
  }),
  dispatch => ({
    save: (item, data) => dispatch(CRUDAction.save(item, data)),
    onClose: () => {
      dispatch(push(PLAYERS_ROUTER_ROOT));
      dispatch(CRUDAction.onCloseEditForm());
    },
    onChange: (field, data) => dispatch(change('player_edit_form' ,field, data))
  })
)(PlayersEditForm);



// WEBPACK FOOTER //
// ./src/components/Players/PlayersEditForm/index.js